export default __webpack_public_path__ + "static/media/0194.8c8a3431.jpg";